<script type="text/javascript">
	import moment from "moment";
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import MapStore from "../../Map/Store";
	import MapLayerManager from "../../Map/MapLayerManager";
    import ModalWindow from "../../UI/ModalWindow.svelte"

	import LoadState from "../../Enums/LoadState";

	import SatCapStore from "./Store";

	let features = SatCapStore.results.features;
    let visible = SatCapStore.meta.visible;
    let loadState = SatCapStore.meta.loadState;

	let chipLoadState = SatCapStore.meta.chipLoadState;
	let chip = SatCapStore.results.currentChip;
	$: {
        if ($visible) {
		    SatCapStore.actions.initMap( MapStore.helpers.getMap() );
		    SatCapStore.actions.init();
        }
		else {
			SatCapStore.actions.deinitMap();
		}
		MapLayerManager.updateVisibleLayers();
	};

</script>

<ModalWindow
	title={`SAR-derived Dark Vessel Detection`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}
	>
	{#if $loadState !== LoadState.LOADED}
		<p>Loading...</p>
	{:else}
		<p>{$features.length} results. See map.</p>

		{#if $chipLoadState === LoadState.LOADING}
			Loading Chip...
		{:else if $chipLoadState === LoadState.LOADED}
			{#if $chip !== ""}
				<img src={$chip} style="width:100%;height:auto;border:1px solid black;"/>
			{/if}
		{/if}
	{/if}
</ModalWindow>

